export default import.meta.ROLLUP_FILE_URL_D9RbB39EXZJ3HSElnnS1Ew